import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import "../Tabellen/SD_anlegen/Formular.css";
import useKeypress from "../ownHooks/pressEsc";

import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
var MonitorApi = require("monitor-api");


export default function VvCreate({ vvInstance, zvInstance, vvArtInstance, evuInstance, reloadData }) {
    const [newVV, setNewVV] = useState(new MonitorApi.CreateVerkehrsvertrag());
    const [zvs, setZvs] = useState([]);
    const [zvsCheck, setZvsCheck] = useState({});
    const [vvArten, setVvArten] = useState([]);
    const [evus, setEvus] = useState([]);

    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        Object.keys(zvsCheck).map(zv => setZvsCheck(pre => ({ ...pre, [zv]: false })));
        setNewVV(new MonitorApi.CreateVerkehrsvertrag());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    function sortZvList(list) {
        return list.sort((a, b) => {
            let ak = a.kurz.toLowerCase();
            let bk = b.kurz.toLowerCase();
            if (ak < bk) {
                return -1;
            }
            if (ak > bk) {
                return 1;
            }
            return 0;
        })
    }

    useEffect(() => {
        let opts = {
            'onlyActive': true // Boolean | 
        };
        zvInstance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
            if (error) {
                console.log(error);
            } else {
                setZvs(sortZvList(data));
                data.map(zv => setZvsCheck(pre => ({ ...pre, [zv.id]: false })));
            }
        })

        vvArtInstance.getVerkehrsvertragsartVerkehrsvertragsartGet((error, data) => {
            if (error) {
                console.log('error', error);
            } else {
                console.log('load vvarten', data);
                setVvArten(data);
            }
        })

        evuInstance.getEvuEisenbahnverkehrsunternehmenGet((error, data) => {
            if (error) {
                console.log('error', error);
            } else {
                console.log('load evu');
                setEvus(data);
            }
        })
    }, [zvInstance, vvArtInstance, evuInstance])


    useEffect(() => {
        const ids = Object.keys(zvsCheck).filter(zv => zvsCheck[zv]);
        setNewVV(pre => ({ ...pre, 'korr_zvs': ids }))
    }, [zvsCheck])

    const saving = event => {
        event.preventDefault();
        console.log(newVV);

        vvInstance.createVerkehrsvertragVerkehrsvertragPost(newVV, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert(`Neuer Verkehrsvertrag ${data.name} erstellt unter der Id: ${data.id}`);
                closeModal();
                reloadData();
            }
        })


    }

    const changingInput = event => {
        event.preventDefault();
        setNewVV(previous => ({ ...previous, [event.target.id]: event.target.value }))
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neuer Verkehrsvertrag</MyNewButton>

            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saving}>
                    <MyModalContentRow>
                        <label>Verkehrsvertrag:
                            <MyModalContentTextInput id="vertrag" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Verkehrsvertragsart:
                            <MyModalContentSelectInput id="id_art" onChange={changingInput} required>
                                <option key={0} defaultValue hidden value="">---Auswahl treffen---</option>
                                {vvArten.map(art => <option value={art.id} key={art.id}>{art.vvart}</option>)}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Eisenbahnverkehrsunternehmen:
                            <MyModalContentSelectInput onChange={changingInput} id="id_evu" required>
                                <option defaultValue={true} hidden={true} value="">---Auswahl treffen---</option>
                                {evus.map(evu => <option value={evu.id} key={evu.id}>{evu.evu}</option>)}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <label>zugehörige Zweckverbände:
                        <ul type="none" className="zv-list">
                            {zvs.map(zv => <li key={zv.id}>
                                <label>
                                    <input type="checkbox" value={zv.id} checked={zvsCheck[zv.id]} onChange={e => setZvsCheck(pre => ({ ...pre, [zv.id]: e.target.checked }))} />
                                    {zv.kurz}
                                </label>
                            </li>)}
                        </ul>
                    </label>
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn:
                            <MyModalContentDateInput id="beginn" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende (optional):
                            <MyModalContentDateInput id="ende" min={newVV.beginn} onChange={changingInput} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput id="kommentar" onChange={changingInput} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}